import React from 'react'
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { LinkContainer } from 'react-router-bootstrap';
import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import { useAuth } from "./../util/auth.js";

function NavbarCustom(props) {   
    const auth = useAuth();
    
    return (       
        <Navbar 
        collapseOnSelect
        bg="transparent" 
        variant="light" 
        expand="md" 
        className="topNav">

            <Navbar.Brand href="/">
            <img
            src="/icon.png"
            alt="Logo"
            height="60"
            className="d-inline-block align-top"
            />     
            </Navbar.Brand>  
               
            <Navbar.Toggle aria-controls="responsive-navbar-nav" className="border-0" />

            <Navbar.Collapse id="navbar-nav">                   
                <Nav className="m-auto float-right">

                <LinkContainer to ="/coffee">
                  <Nav.Link>coffee</Nav.Link>
                </LinkContainer> 

                <LinkContainer to ="/add">
                <Nav.Link>add</Nav.Link>
                </LinkContainer>

                <LinkContainer to ="/search">
                <Nav.Link>search</Nav.Link>
                </LinkContainer>
               
                {!auth.user && (
              <LinkContainer to="/auth/signin">
                <Nav.Link active={false}>my coffee</Nav.Link>
              </LinkContainer>
            )}

            {auth.user && (
                <LinkContainer to="/dashboard">
                <Nav.Link>my coffee</Nav.Link>
              </LinkContainer>
            )}            

              {auth.user && (
              <NavDropdown id="dropdown" title="account" alignRight={true}>              

                <LinkContainer to="/settings/general">
                  <NavDropdown.Item active={false}>account settings</NavDropdown.Item>
                </LinkContainer>

                <Dropdown.Divider />

                <LinkContainer to="/auth/signout">
                  <NavDropdown.Item
                    active={false}
                    onClick={(e) => {
                      e.preventDefault();
                      auth.signout();
                    }}
                  >
                    Sign out
                  </NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>
            )}

                </Nav>               
            </Navbar.Collapse>
            
        </Navbar>
        
    )
}

export default NavbarCustom

